<template>
    <div class="afu-pb-64 afu-px-5 md:afu-px-0">
        <div class="af-dashboard-container afu-flex">
            <div class="af-dashboard-content afu-relative afu-flex-1">
                <RouterView />
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'DefaultNoMenu',

        data() {
            return {
            };
        },

        methods: {},
    };
</script>
